import React, {
	PureComponent
} from "react";

import Picker from "./Picker";
import DatePicker from "./DatePicker";
import AESwitch from "./AESwitch";
import AELabel from "./AELabel";
import Input from "./Input";
import InputList from "./InputList";
import CodeInput from "./CodeInput";
import PhoneInput from "./PhoneInput";
import Days from "./Days";
import Time from "./Time";
import SubForm from "./Subform";
import SubFormWithChangeAllTo from "./SubFormWithChangeAllTo";
import SearchBox from "./SearchBox";
import MessageBox from "./MessageBox";
import FileList from "./FileList";
import FilePicker from "./FilePicker";
import CameraPicker from "./CameraPicker";
import VideoPicker from "./VideoPicker";
import Checkbox from "./Checkbox";
import Buttons from "./Buttons";
import inputTypes from "./Layout/inputTypes";
import RangeInput from "./RangeInput";
import Output from "../Outputs/Output";
import InputCall from "./InputCall";
import FormLink from "./FormLink";
import Reading from "./Reading";
import DynamicObject from "./DynamicObject";
import NestedInput from "./NestedInput";
import IncrementalButtons from "./IncrementalButtons";
import RadioButtons from "./RadioButtons";
import ResourceLink from "./ResourceLink";
import Checkboxes from "./Checkboxes";
import BluetoothScanner from "./BluetoothScanner";
import ExternalForm from "./ExternalForm";
import SignatureInline from "./Signature/SignatureInline";
import CustomOptions from "./CustomOption";
import FileSingle from "./FileSingle";
import UnsupportedFeature from "./UnsupportedFeature";
export default class FormInput extends PureComponent {

	render(){
		var props = this.props;
		var propertySchema = props.schema;

		var Component = null;
		var type = propertySchema.type;
		var format = propertySchema.format;
		var label = propertySchema.label;
		var enumerated = propertySchema.enum;
		var inputType = propertySchema.inputType;
		var hidden = propertySchema.hidden;
		const changeAllTo = propertySchema.changeAllTo;
		const unsupportedFeatures = props.unsupportedFeatures || [];

		if(unsupportedFeatures?.includes(inputType) || unsupportedFeatures?.includes(format)){
			return (
				<UnsupportedFeature {...props} />
			);
		}

		if(hidden){
			Component = () => null;
		}
		else if(!inputType){
			if(label)
				Component = AELabel;
			else if(format === "video")
				Component = VideoPicker;
			else if(format === "switch")
				Component = AESwitch;
			else if(format === "buttons")
				Component = Buttons;
			else if(format === "checkbox" || type === "boolean")
				Component = Checkbox;
			else if(enumerated)
				Component = Picker;
			else if(format === "date" || format === "date-time")
				Component = DatePicker;
			else if (type === "object") {
				if(format === "time")
					Component = Time;
				else if(format === "days")
					Component = Days;
				else if(format === "phone")
					Component = PhoneInput;
				else if(format === "code")
					Component = CodeInput;
				else if(format === "file")
					Component = FilePicker;
				else if(format === "picture")
					Component = CameraPicker;
				else if (changeAllTo)
					Component = SubFormWithChangeAllTo;
				else
					Component = SubForm;
			}
			else if(type === "array"){
				if(format === "file")
					Component = FileList;
				else Component = InputList;
			}
			else if(format === "search")
				Component = SearchBox;
			else if(format === "message")
				Component = MessageBox;
			else Component = Input;
		}else{
			if(inputType === "label")
				Component = AELabel;
			else if (inputType === "reading")
				Component = Reading;
			else if(inputType === "call")
				Component = InputCall;
			else if(inputType === "link:form")
				Component = FormLink;
			else if(inputType === "link:resource")
				Component = ResourceLink;
			else if(inputType === "switch")
				Component = AESwitch;
			else if(inputType === "buttons")
				Component = Buttons;	// not in mockingbird schema
			else if(inputType === "checkbox")
				Component = Checkbox;
			else if(inputType === "dropdown")
				Component = Picker;
			else if(inputType === "date")
				Component = DatePicker;
			else if(inputType === "time")
				Component = Time;
			else if(inputType === "days")
				Component = Days;
			else if(inputType === "phone")
				Component = PhoneInput;	// not in mockingbird schema
			else if(inputType === "code")
				Component = CodeInput;	// not in mockingbird schema
			else if(inputType === "file")
				Component = FileSingle;
			else if(inputType === "picture")
				Component = CameraPicker;	// not in mockingbird schema
			else if(inputType === "video")
				Component = VideoPicker;	// not in mockingbird schema
			else if(inputType === "fileList")
				Component = FileList;
			else if(inputType === "search")
				Component = SearchBox;
			else if(inputType === "message")
				Component = MessageBox;
			else if(inputType === "text")
				Component = Input;
			else if(inputType === "scale")
				Component = RangeInput;
			else if(inputType === "increment")
				Component = IncrementalButtons;
			else if(inputType === "radio")
				Component = RadioButtons;
			else if(inputType === "output")
				Component = Output;
			else if(inputType === "dynamic")
				Component = DynamicObject;
			else if(inputType === "nested")
				Component = NestedInput;
			else if(inputType === "bluetooth:scanner")
				Component = BluetoothScanner;
			else if (inputType === "externalform")
				Component = ExternalForm;
			else if(inputType === "checkboxes")
				Component = Checkboxes;
			else if (inputType === "signature")
				Component = SignatureInline;
			else if(inputType === "customOptions")
				Component = CustomOptions;
			else if(type === "object" || inputType === "subform") {
				if (changeAllTo)
					Component = SubFormWithChangeAllTo;
				else
					Component = SubForm;
			}
			else if (type === "array" || inputType === "list")
				Component = InputList;
			else Component = Input;
		}

		return React.createElement(Component, props);
	}
}

FormInput.propTypes = inputTypes;
